import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';
import './SlidingTabs.scss';

// Нужно прокинуть в SlidingTabs props tabsArray
// к примеру tabsArray={[{label: 'Use of funds', content: <p>Content 2<p>}, ...]}

// const tabsArray = [
// 	{
// 		label: 'Source of funds',
// 		content: <AMLDetailList amlDetailsList={amlDetailsList} />,
// 	},
// 	{
// 		label: 'Use of funds',
// 		content: <AMLDetailList amlDetailsList={amlDetailsList2} />,
// 	},
// ];

const SlidingTabs = ({
	tabsArray = [
		{ label: 'label', content: <p>content</p> },
		{ label: 'label2', content: <p>content 2</p> },
	],
}) => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);
	const [tabWith, setTabWith] = useState(0);
	const headerRef = useRef(null);

	useLayoutEffect(() => {
		if (!headerRef.current) return;

		const element = headerRef.current;
		const calculateTabWith = () => setTabWith((element.clientWidth - 2) / tabsArray.length || 1);
		calculateTabWith();
		const resizeObserver = new ResizeObserver(calculateTabWith);
		resizeObserver.observe(element);

		return () => resizeObserver.disconnect();
	}, []);

	const tabClick = tabIndex => {
		setSelectedTabIndex(tabIndex);
	};

	if (tabsArray.length < 1) return null;

	return (
		<div className='SlidingTabs'>
			<div
				className={classNames('SlidingTabs_header', {
					SlidingTabs_header_separators: tabsArray.length > 2,
				})}
				ref={headerRef}
			>
				<div
					className='SlidingTabs_header_slidingIndicator'
					style={{ '--tabWidth': `${tabWith}px`, '--indicatorX': `${tabWith * selectedTabIndex}px` }}
				/>
				{tabsArray.map((tab, index) => (
					<div
						key={index}
						className='SlidingTabs_header_tab'
						style={{ '--tabWidth': `${tabWith}px` }}
						onClick={() => tabClick(index)}
					>
						<span
							className={classNames('SlidingTabs_header_tab_text', {
								SlidingTabs_header_tab_text_selected: index === selectedTabIndex,
							})}
						>
							{tab?.label}
						</span>
					</div>
				))}
			</div>
			<div className='SlidingTabs_content'>{tabsArray[selectedTabIndex].content}</div>
		</div>
	);
};

export default SlidingTabs;

SlidingTabs.propTypes = {
	tabsArray: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
			content: PropTypes.node.isRequired,
		})
	).isRequired,
};
